import React, { useState,useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { useLocation } from "react-router-dom";

const Section1 = ({ url }) => {


    // const [showCalendar, setShowCalendar] = useState(false);

    // const handleCloseCalendar = () => setShowCalendar(false);

    // // Close on Escape key
    // useEffect(() => {
    // const handleKeyDown = (e) => {
    //     if (e.key === "Escape") handleCloseCalendar();
    // };
    // if (showCalendar) {
    //     document.addEventListener("keydown", handleKeyDown);
    //     document.body.style.overflow = "hidden"; // prevent bg scroll
    // }
    // return () => {
    //     document.removeEventListener("keydown", handleKeyDown);
    //     document.body.style.overflow = "";
    // };
    // }, [showCalendar]);



   const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");

      // Delay ensures DOM is rendered
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100); // small delay is key
    }
  }, [location]);


const [isSubmitting, setIsSubmitting] = useState(false);

const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: "",
  company: "",
  message: "",
  document: null,
  website: "" // honeypot field
});

const handleChange = (e) => {
  if (e.target.type === "file") {
    setFormData({ ...formData, document: e.target.files[0] || null });
  } else {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }
};

const handleSubmit = async (e) => {
  e.preventDefault();

  // 🛑 Bot protection
  if (formData.website) {
    console.warn("Bot detected");
    return;
  }

  setIsSubmitting(true);

  try {
    const payload = new FormData();
    payload.append("name", formData.name);
    payload.append("email", formData.email);
    payload.append("phone", formData.phone);
    payload.append("company", formData.company);
    payload.append("message", formData.message);
    if (formData.document) {
      payload.append("document", formData.document);
    }

    const response = await axios.post(
      "https://devdigital.exdnow.com/digital-api/extra.php",
      payload,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );

    if (response.data.response_code == 200) {
      alert("Quote sent successfully. Our Team will get back to you soon!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        company: "",
        message: "",
        document: null,
        website: ""
      });
    } else {
      alert("Error sending message");
    }
  } catch (err) {
    alert("Error sending message");
    console.log(err);
  } finally {
    setIsSubmitting(false);
  }
};

  useEffect(() => {
    const spotlightSize = 400;

    function handleMouseMove(event) {
      if (window.event) {
        event = window.event;
      }
      let titleRect = document
        .querySelector(".hollow-txt")
        .getBoundingClientRect();
      let mouseX = event.clientX;
      let spotlightX = mouseX - spotlightSize / 2 - titleRect.left;
      let mouseY = event.clientY;
      let spotlightY = mouseY - spotlightSize / 2 - titleRect.top;
      const element = document.querySelector(".hollow-txt");
      element.style.backgroundPosition = spotlightX + "px " + spotlightY + "px";
    }

    document.addEventListener("mousemove", handleMouseMove, false);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <>
      <section className="contact-section-1" style={{
      backgroundImage: "url(" + url + "images/contact-us/main-banner.jpg)",
    }}>
        <div className="container sect-1-container">
          <div
            className="txt-1 col-12"
            data-aos="fade-up"
            data-aos-duration="1200"
          >
            <h1 className="hollow-txt">
              <span>
                <span className="white-txt">Lets Talk</span> About What You Are Trying to Build
              </span>
            </h1>
          </div>
          {/* <div
            className="services-desc"
            data-aos="fade-up"
            data-aos-duration="1400"
          >
            <h6 className="desc">
              From start to scaling, ExD Digital is there to help your brand at
              any stage, whether it be launch or growth, we've got you covered.
              so contact us <span>NOW!</span>
            </h6>
          </div> */}

          <div className="scroller">
            {/* <p className="scroller-text">Scroll Down</p> */}
            <a className="btn btn-gradient" href="#contact-section-2" rel="noopener noreferrer">
                Get A Quote
            </a>
          </div>
        </div>
      </section>
    <section className="contact-section-form" id="contact-section-2">
        <div className="container form-container overflow-hidden" id="contact-form">

            {/* Intro Text Section */}
            <div className="contact-intro" data-aos="fade-up" data-aos-duration="1000">
                <p className="contact-intro-text">
                    Whether you are ready to start a project, exploring what is possible, or just want an honest
                    conversation about your options, ExD Digital is ready to listen.
                </p>
                <p className="contact-intro-highlight">
                    No pitch. No pressure. A real conversation about your business.
                </p>
            </div>
            {/* Discovery Call Card */}
            <div className="discovery-card" data-aos="fade-up" data-aos-duration="1000">
            <div className="discovery-card__inner">
                <div className="discovery-card__header">
                    <div className="discovery-icon-wrapper">
                        <FontAwesomeIcon icon={faCalendar} style={{ fontSize: "1.6rem" }} />
                    </div>
                    <h2 className="discovery-title">Consultation Call</h2>
                </div>
                <h3 className="discovery-subtitle">Pick a Time That Works for You</h3>
                <p className="discovery-desc">
                Select an available slot in our calendar and book a free 30-minute discovery call. Come
                with your challenge, your context, and your questions. We will come prepared with honest answers.
                </p>
                {/* <button className="discovery-btn" onClick={() => setShowCalendar(true)}>
                Book Your Free Discovery Call &rarr;
                </button> */}
                <a href="https://calendar.app.google/zrGikproai5G8KVb8"
                    target="_blank"
                    rel="noreferrer"
                    className="discovery-btn"
                >
                Book Your Free Consultation Call &rarr;
                </a>
                <p className="discovery-note">30 minutes. Instant confirmation. No preparation required on your end.</p>
            </div>
            </div>

            {/* Request Quote Form */}
            <div className="form-wrapper" data-aos="fade-up" data-aos-duration="1200">
            <h2 className="form-title">Request Quote</h2>
            <p className="form-subtitle-bold">Not Ready to Schedule a Call? No Problem.</p>
            <p className="form-subtitle">
                Fill in your details and tell us a little about what you are working on. Our team will review your requirements
                and get back to you within 1 business day with the next steps.
            </p>

            <form className="contact-form" onSubmit={handleSubmit}>
                <div className="row">
                <div className="col-lg-6">
                    <label className="form-label">Name*</label>
                    <input type="text" name="name" className="form-input"
                    value={formData.name} onChange={handleChange} required />
                </div>
                <div className="col-lg-6">
                    <label className="form-label">Official Email*</label>
                    <input type="email" name="email" className="form-input"
                    value={formData.email} onChange={handleChange} required />
                </div>
                </div>

                <div className="row">
                <div className="col-lg-6">
                    <label className="form-label">Phone Number*</label>
                    <input type="text" name="phone" className="form-input"
                    value={formData.phone} onChange={handleChange} required />
                </div>
                <div className="col-lg-6">
                    <label className="form-label">Business Name*</label>
                    <input type="text" name="company" className="form-input"
                    value={formData.company} onChange={handleChange} required />
                </div>
                </div>

                {/* Honeypot */}
                <input
                type="text"
                name="website"
                value={formData.website}
                onChange={handleChange}
                tabIndex="-1"
                autoComplete="off"
                aria-hidden="true"
                style={{ position: "absolute", left: "-9999px", height: "0", width: "0", overflow: "hidden" }}
                />

                <div className="form-group">
                <label className="form-label">Message</label>
                <textarea
                    name="message"
                    className="form-textarea"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                ></textarea>
                </div>

                <div className="form-group">
                <label className="form-label">Requirement document (if any)</label>
                <div className="file-upload-wrapper">
                    <label className="file-choose-btn">
                    <span>+ Choose File</span>
                    <input type="file" name="document" onChange={handleChange} hidden />
                    </label>
                    <span className="file-name-display">
                    {formData.document ? formData.document.name : "No file chosen"}
                    </span>
                </div>
                </div>

              <div className="btn-wrapper">
                <button
                    type="submit"
                    className={`send-btn ${isSubmitting ? "send-btn--inactive" : ""}`}
                    disabled={isSubmitting}
                >
                    {isSubmitting ? (
                    <><span className="contact-spinner"></span> Sending...</>
                    ) : "Submit"}
                </button>
                </div>
            </form>
            </div>

        </div>
    {/* Calendar Modal */}
        {/* {showCalendar && (
        <div className="calendar-overlay" onClick={handleCloseCalendar}>
            <div className="calendar-modal" onClick={(e) => e.stopPropagation()}>
            <button className="calendar-close-btn" onClick={handleCloseCalendar}>✕</button>
            <iframe
                src="https://calendar.google.com/calendar/appointments/schedules/YOUR_SCHEDULING_LINK?gv=true"
                style={{ border: 0 }}
                width="100%"
                height="100%"
                frameBorder="0"
                title="Book a Discovery Call"
            ></iframe>
            </div>
        </div>
        )} */}
    </section>
    {/* <section className="email-direct-section">
        <div className="container email-direct-container overflow-hidden">
            <div className="email-direct-wrapper" data-aos="fade-up" data-aos-duration="1000">
            <h2 className="email-direct-title">Email Us Directly</h2>
            <p className="email-direct-bold">Prefer to Write Your Own Message?</p>
            <p className="email-direct-desc">
                If you would rather send an email in your own words, use the addresses below. Route your
                message to the team most relevant to your enquiry for the fastest response.
            </p>

            <div className="email-direct-link-wrapper">
                <span className="email-icon">✉</span>
                <a href="mailto:sales@exddigital.com" className="email-direct-link">
                sales@exddigital.com
                </a>
            </div>

            <p className="email-direct-note">All emails receive a response within 1 business day.</p>
            </div>
        </div>
    </section> */}


    </>
  );
};

export default Section1;
